import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";
import { Badge } from "./ui/badge";
import type { Health } from "@/lib/types";

const TONE: Record<Health, "success" | "warning" | "danger"> = {
  green: "success",
  yellow: "warning",
  red: "danger",
};

const LABEL: Record<Health, string> = {
  green: "Healthy",
  yellow: "Watch",
  red: "Critical",
};

export function HealthBadge({
  health,
  reasons,
  compact,
}: {
  health: Health;
  reasons?: string[];
  compact?: boolean;
}) {
  const dot = (
    <span
      className={
        health === "green"
          ? "inline-block h-1.5 w-1.5 rounded-full bg-success"
          : health === "yellow"
            ? "inline-block h-1.5 w-1.5 rounded-full bg-warning"
            : "inline-block h-1.5 w-1.5 rounded-full bg-destructive"
      }
    />
  );
  const body = (
    <Badge tone={TONE[health]} className="gap-1.5">
      {dot}
      {compact ? null : LABEL[health]}
    </Badge>
  );
  if (!reasons?.length) return body;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span>{body}</span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        <ul className="list-disc space-y-0.5 pl-4">
          {reasons.map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>
      </TooltipContent>
    </Tooltip>
  );
}
